import { render, staticRenderFns } from "./XenoPage.vue?vue&type=template&id=715e9faa&scoped=true&"
import script from "./XenoPage.vue?vue&type=script&lang=js&"
export * from "./XenoPage.vue?vue&type=script&lang=js&"
import style0 from "./XenoPage.vue?vue&type=style&index=0&id=715e9faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e9faa",
  null
  
)

export default component.exports